module.exports = __webpack_public_path__ + "media/game-over.f7815e09.mp3";